import React from "react";

import PropTypes from "prop-types";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { Footer } from "../../components/Footer/Footer";

export function RankingGeral({ app, config }) {
  return (
    <div className="app ranking-geral">
      <div className="appContent">
        <LayoutWrapper>
          <Grid className="container-ranking-geral">
            <Card
              app={app}
              header={{
                hardTitle: "Ranking Geral",
              }}
              exportContainer
              exportTable
              exportTableId="FEQSsT"
              style={{ margin: "0 0 16px" }}
            >
              <NativeObject
                app={app}
                key="FEQSsT"
                reference={{ id: "FEQSsT" }}
                style={{
                  width: "100%",
                  height: "calc(100vh - 240px)",
                }}
              />
            </Card>
          </Grid>

          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

RankingGeral.defaultProps = {
  app: null,
  config: {},
};

RankingGeral.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};
